<template>
<div id="create-partner">
  <h2>Create Partner</h2>

  <partner-form></partner-form>
</div>
</template>

<script>
import PartnerForm from '@/components/PartnerForm'

export default {
  data () {
    return {}
  },

  components: {
    'partner-form': PartnerForm
  },

  methods: {
    processErrors (resp) {
      this.$parent.processErrors(resp)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PartnerCreate.vue